module.exports = __webpack_public_path__ + "static/img/p12.e2942163.png";